import { Controller } from "stimulus"
import { formatMoney, formatMoneyMillis, formatWeight } from 'formatters';
import { setupCountryCascade, setupCascade } from 'locations';

export default class extends Controller {
  static get targets() {
    return ['show', 'edit', 'editLink'];
  } 

  connect() {
    this.doShow();
  }
  
  doEdit(event) {
    if (event) { event.preventDefault(); }
    $(this.showTarget).hide();
    $(this.editLinkTarget).hide();
    $(this.editTarget).show();
  }

  doShow(event) {
    if (event) { event.preventDefault(); }
    $(this.showTarget).show();
    $(this.editLinkTarget).show();
    $(this.editTarget).hide();
  }
}
